import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Search } from 'components/SearchBar/components';
import {
  Modal,
  Card,
  CardContent,
  CardActions,
  Button,
  CardHeader,
  Divider,
  TableHead,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid
} from '@material-ui/core';
import ws from 'utils/ws';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 850,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  content: {
    padding: 0
  },
  actions: {
    justifyContent: 'flex-end'
  },
  progress: {
    marginBottom: theme.spacing(2)
  },
  fileName: {
    marginBottom: theme.spacing(2)
  },
  image: {
    width: '100%'
  },
  details: {
    padding: theme.spacing(2)
  },
  search: {
    minWidth: 480,
    maxWidth: 480,
    flexBasis: 480
  },
  tableContainer: {
    minHeight: 431,
    maxHeight: 431,
    overflowY: 'auto'
  },
  searchContainer: {
    padding: theme.spacing(2)
  },
  selfSearch: {
    marginTop: 3
  },
  buttonCell: {
    paddingTop: 0,
    paddingBottom: 0,
    width: 100
  },
  buttonExtraSmall: {
    padding: '1px 8px',
    fontSize: '0.8125rem'
  },
  labelCell: {
    paddingTop: 0,
    paddingBottom: 0
  }
}));

const SelectCells = props => {
  const { open, onClose, onSelect, selectedIds } = props;

  const classes = useStyles();

  const [searchName, setSearchName] = useState('GTS - ');
  const [walkcollections, setWalkCollections] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchedWalkCollections = walkcollections.filter(wc =>
    wc.name.toUpperCase().includes(searchName.trim().toUpperCase())
  );

  const handleSearchFieldChange = value => {
    setSearchName(value);
  };

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      setLoading(true);
      ws.get(`/events/data_sets/`).then(response => {
        setWalkCollections(response.data.result);
        setLoading(false);
      });
    }

    return () => {
      mounted = false;
    };
  }, []);

  if (!open) {
    return null;
  }

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={classes.root}>
        <CardHeader title="Select Walk Collection" />
        <Divider />

        <CardContent className={classes.content}>
          <div className={classes.searchContainer}>
            <Grid container spacing={3}>
              <Grid item>
                <Search
                  autoFocus={true}
                  placeholder="Name"
                  value={searchName}
                  onSearchValueChange={handleSearchFieldChange}
                  className={classes.search}
                  hideSearchButton={true}
                />
              </Grid>
            </Grid>
          </div>
          <Divider />
          <div className={classes.tableContainer}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ width: '0%' }} />
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchedWalkCollections.map(walkCollection => (
                  <TableRow key={walkCollection.id} hover>
                    <TableCell className={classes.buttonCell}>
                      <Button
                        disabled={selectedIds?.indexOf(walkCollection.id) > -1}
                        className={classes.buttonExtraSmall}
                        size="small"
                        variant="outlined"
                        onClick={() => onSelect(walkCollection)}>
                        Select
                      </Button>
                    </TableCell>
                    <TableCell>{walkCollection.name} </TableCell>
                  </TableRow>
                ))}
                {!loading && searchedWalkCollections.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={onClose} variant="contained">
            Done
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
};

SelectCells.displayName = 'SelectCells';

SelectCells.propTypes = {
  className: PropTypes.string
};

export default SelectCells;
